// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Local Imports
import endPoints from '@/redux/constant';
import axios from '@/redux/http';
import { PURGE } from 'redux-persist';

// Initial State
const initialState = {
  loading: false,
  error: null,
  instagramData: null,
  instaDetails: null,
  instaAccessToken: '',
  instaUserId: '',
  isInstaConnected: false,
  instaAuthSuccess: false,
};

// Check Instagram API Fn
export const getInstagramDataAPIFn = createAsyncThunk(
  'auth/instagramData',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${endPoints.getInstaUnauthenticatedData}${values?.username}`);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Get Instagram Details
export const getInstaDetailsAPIFn = createAsyncThunk(
  'auth/getInstaDetails',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${endPoints.getCreatorInsight}?userId=${values?.userId}`);
      return data?.result;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Login User Slices
export const instagramDataSlice = createSlice({
  name: 'auth/instagramData',
  initialState,
  reducers: {
    updateInstaDetails: (state, action) => {
      state.instaAccessToken = action.payload.accessToken;
      state.isInstaConnected = true;
    },
    updateInstaAuthSuccess: (state, action) => {
      state.instaAuthSuccess = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInstagramDataAPIFn.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.instagramData = null;
      })
      .addCase(getInstagramDataAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.instagramData = action.payload;
        state.error = null;
      })
      .addCase(getInstagramDataAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.instagramData = null;
      })
      .addCase(getInstaDetailsAPIFn.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.instaDetails = null;
      })
      .addCase(getInstaDetailsAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.instaDetails = action.payload;
        state.error = null;
      })
      .addCase(getInstaDetailsAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.instaDetails = null;
      })
      .addCase(PURGE, (state) => {
        state.instagramData = null;
        state.loading = false;
        state.error = null;
      });
  },
});

export const { updateInstaDetails, updateInstaAuthSuccess } = instagramDataSlice.actions;

export default instagramDataSlice.reducer;